import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

const Schema = z.object({
  level: z.enum(["error", "console_error", "unhandled_rejection"]),
  message: z.string().min(1).max(2000),
  stack: z.string().max(8000).optional().nullable(),
  url: z.string().max(2000).optional().nullable(),
  user_agent: z.string().max(500).optional().nullable(),
  extra: z.record(z.string(), z.any()).optional().nullable(),
});

export const reportClientError = createServerFn({ method: "POST" })
  .inputValidator((input) => Schema.parse(input))
  .handler(async ({ data }) => {
    const { error } = await supabaseAdmin.from("system_logs").insert({
      log_type: `client_${data.level}`,
      message: data.message.slice(0, 2000),
      detail: {
        stack: data.stack ?? null,
        url: data.url ?? null,
        user_agent: data.user_agent ?? null,
        extra: data.extra ?? null,
      },
    });
    if (error) throw new Error(error.message);
    return { ok: true };
  });